var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#276E65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 43.3332V41.6665C18.3335 38.5723 19.5627 35.6048 21.7506 33.4169C23.9385 31.229 26.906 29.9998 30.0002 29.9998M30.0002 29.9998C33.0944 29.9998 36.0618 31.229 38.2497 33.4169C40.4377 35.6048 41.6668 38.5723 41.6668 41.6665V43.3332M30.0002 29.9998C31.7683 29.9998 33.464 29.2975 34.7142 28.0472C35.9645 26.797 36.6668 25.1013 36.6668 23.3332C36.6668 21.5651 35.9645 19.8694 34.7142 18.6191C33.464 17.3689 31.7683 16.6665 30.0002 16.6665C28.2321 16.6665 26.5364 17.3689 25.2861 18.6191C24.0359 19.8694 23.3335 21.5651 23.3335 23.3332C23.3335 25.1013 24.0359 26.797 25.2861 28.0472C26.5364 29.2975 28.2321 29.9998 30.0002 29.9998Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualFrame);
export default __webpack_public_path__ + "static/media/individual-frame.f7e7a698c67963dc2b0283e111687b93.svg";
export { ForwardRef as ReactComponent };